import InfoIcon from '@mui/icons-material/Info';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { UISubmissionStatus } from '@ifa/types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { grey } from '@mui/material/colors';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useIfaStore } from '@ifa/store';
import { useContext, useState } from 'react';

import DashboardTableActionsDownload from './DashboardTableActionsDownload';
import { DeleteModalContext } from './DeleteModal';

export type DashboardTableActionsProps = {
    status: UISubmissionStatus;
    id: number;
};

const iconStyles = {
    marginBottom: '0.25rem',
    marginRight: '0.25rem',
    fontSize: '1.15rem',
};

// TODO: RECEIVED is not in the status enum yet
function DashboardTableActions({ status, id }: DashboardTableActionsProps) {
    const openDrawer = useIfaStore(state => state.drawer.openDrawer);
    const { setIdToDelete } = useContext(DeleteModalContext);
    const [, setForceRender] = useState(0);

    const handleDelete = (idToDelete: number | null) => (_e: any) => {
        if (!idToDelete) {
            return;
        }
        setIdToDelete(idToDelete);
    };

    const handleClickAway = () => (_e: any) => {
        setForceRender(prev => prev + 1);
    };

    return (
        <Box
            alignItems="center"
            display="flex"
            sx={{
                width: '100%',
                minWidth: '320px',
            }}
        >
            <Box flex="0 0 35%" marginRight="5%" alignContent="center" display="flex">
                {status === 'READY' && <DashboardTableActionsDownload submissionDetailsId={id} />}
            </Box>

            <Box flex="0 0 35%" marginRight="5%" alignContent="center" display="flex">
                <Link
                    sx={{ cursor: 'pointer', display: 'inline' }}
                    role="button"
                    data-cy="actions-details"
                    onClick={() => {
                        openDrawer(id);
                    }}
                >
                    <Box sx={{ display: 'inline-flex' }}>
                        <InfoIcon color="primary" sx={iconStyles} />
                        <Typography component="span" sx={{ fontSize: '13px' }}>
                            Request&nbsp;details
                        </Typography>
                    </Box>
                </Link>
            </Box>

            <Box flex="0 0 20%" display="flex" justifyContent="flex-end">
                {/* TODO - verify status checks after aligning statuses with BE */}
                {status !== 'RECEIVED' && status !== 'PROCESSING' && (
                    <ClickAwayListener onClickAway={handleClickAway()}>
                        <IconButton
                            onClick={handleDelete(id)}
                            aria-label="Delete form request"
                            name="Delete form request"
                            size="small"
                            role="button"
                            data-cy="actions-delete"
                        >
                            <DeleteIcon sx={{ fontSize: '1.15rem', color: grey[700] }} />
                        </IconButton>
                    </ClickAwayListener>
                )}
            </Box>
        </Box>
    );
}

export default DashboardTableActions;
